import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {WorkPermitsFilters} from "./work-permits-filter.interface";
import {UtilsService} from "../../../shared/utils.service";

@Component({
  selector: 'app-work-permits-filter',
  templateUrl: './work-permits-filter.component.html',
  styleUrls: ['./work-permits-filter.component.scss']
})
export class WorkPermitsFilterComponent implements OnInit {
  filters: WorkPermitsFilters = {
    industry_id: '',
    industries: []
  } as WorkPermitsFilters;

  constructor(
    private utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<WorkPermitsFilterComponent>
  ) {
    // set a default industry id selection of zero if no selected values are passed through
    if (typeof this.data['selected_industry_id'] === 'undefined') {
      this.data['selected_industry_id'] = '';
    }
  }

  ngOnInit(): void {
    // Get Industries
    this.getIndustries();

    this.filters.industry_id = this.data['selected_industry_id'];
  }

  private async getIndustries() {
    this.filters.industries = await this.utils.getIndustries();
  }

  /**
   * Clears the filter data and closes the window.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the data.
    this.filters.industry_id = '';
    // Save and close.
    this.onSaveAndClose();
  }

  /**
   * Saves the updated filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    let response: any;

    response = {
      industry_id: this.filters.industry_id
    }

    this.dialogRef.close(response);
  }
}
